import { SCENE_TRANSITION_KEY_DRAG_ON } from 'js/config/consts';
import { SCENE_DIRECTION_KEYS } from 'js/config/sceneTransitionsOptions';

export const isValidDirectionForType = (type: string, direction?: string) => {
  if (type === SCENE_TRANSITION_KEY_DRAG_ON && direction) {
    return true;
  }

  switch (direction) {
    case SCENE_DIRECTION_KEYS.UP:
    case SCENE_DIRECTION_KEYS.DOWN:
    case SCENE_DIRECTION_KEYS.LEFT:
    case SCENE_DIRECTION_KEYS.RIGHT:
      return true;

    default:
      return false;
  }
};
